import { createAction } from '@reduxjs/toolkit';

export const setLoading = createAction<boolean>('setLoading');

export const setUploadProgress = createAction<number>('setUploadProgress');

export const setLightMode = createAction<boolean>('setLightMode');

export const setLanguage = createAction<'FA' | 'EN'>('setLanguage');
